<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)"
size = "medium"
color = "#fff"
type = "timer"
[fullScreen] = "true"><p style="color: white" > {{spinnerMessage }} </p></ngx-spinner>
<router-outlet></router-outlet>
<!-- Processing. Please Wait.... -->
<!-- <div *ngIf="message;">
  <h1>{{ message.notification.title }}</h1>
  <h2>{{ message.notification.body }}</h2>
</div>
<div *ngIf="!message;">
  No Message Arrived
</div> -->
